let zh = {},en = {};

const ctxZh  =require.context(
  '../assets/lang/',
  true,
  /zh\.js$/
)
const ctxEn  =require.context(
  '../assets/lang/',
  true,
  /en\.js$/
)


ctxZh.keys().map(item=> {
  const _tmp = ctxZh(item);
  _tmp.default && (()=>{
    zh = Object.assign({}, zh, _tmp.default)
  })()
})
ctxEn.keys().map(item=> {
  const _tmp = ctxEn(item);
  _tmp.default && (()=>{
    en = Object.assign({}, en, _tmp.default)
  })()
})

export {
  zh,
  en
}
